module.exports = __webpack_public_path__ + "img/BM_Logo_Full_Size.ca64bc98.png";